// web/src/components/SpotlightCard.tsx
// From React Bits (SpotlightCard, JS+CSS variant), converted to TypeScript. A
// radial spotlight follows the pointer across the card. Accepts a `style` prop so
// it can layer onto the existing frosted "my deck" card (which sets its own
// background gradient per mode). See SpotlightCard.css for the adaptation note.
import { useRef } from "react";
import type { CSSProperties, JSX, MouseEvent as ReactMouseEvent, ReactNode } from "react";
import "./SpotlightCard.css";

export interface SpotlightCardProps {
  children?: ReactNode;
  className?: string;
  spotlightColor?: string;
  style?: CSSProperties;
}

export default function SpotlightCard({
  children,
  className = "",
  spotlightColor = "rgba(255, 255, 255, 0.25)",
  style,
}: SpotlightCardProps): JSX.Element {
  const divRef = useRef<HTMLDivElement>(null);

  const handleMouseMove = (e: ReactMouseEvent<HTMLDivElement>) => {
    const el = divRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty("--mouse-x", `${e.clientX - rect.left}px`);
    el.style.setProperty("--mouse-y", `${e.clientY - rect.top}px`);
    el.style.setProperty("--spotlight-color", spotlightColor);
  };

  return (
    <div ref={divRef} onMouseMove={handleMouseMove} className={`card-spotlight ${className}`} style={style}>
      {children}
    </div>
  );
}
